const S = {
  wrapper: { marginTop:'10px', padding:'40px', border:'3px solid #8a6a00', fontFamily:"'Georgia', serif", color:'#1a1200', lineHeight:'1.7', background:'#fffdf0' },
  h1: { fontSize:'2rem', fontWeight:'700', borderBottom:'3px solid #d4a000', paddingBottom:'8px', marginBottom:'24px', color:'#7a4f00' },
  h2: { fontSize:'1.3rem', fontWeight:'700', color:'#b88000', marginTop:'36px', marginBottom:'12px', borderLeft:'4px solid #d4a000', paddingLeft:'10px' },
  p: { marginBottom:'12px', fontSize:'0.97rem' },
  infoBox: { background:'#fffbe6', border:'2px solid #d4a000', borderRadius:'6px', padding:'16px 20px', margin:'16px 0' },
  infoBoxTitle: { fontWeight:'700', fontFamily:"'Courier New', monospace", fontSize:'0.88rem', color:'#7a4f00', marginBottom:'8px' },
  infoBoxItem: { fontSize:'0.9rem', margin:'4px 0', paddingLeft:'12px', borderLeft:'2px solid #d4a000' },
  table: { width:'100%', borderCollapse:'collapse', marginBottom:'20px', fontSize:'0.92rem' },
  th: { background:'#b88000', color:'#fff', padding:'10px 14px', textAlign:'left', fontWeight:'700', fontSize:'0.9rem' },
  tdE: { padding:'10px 14px', borderBottom:'1px solid #f0d98a', verticalAlign:'top', background:'#fffbee' },
  tdO: { padding:'10px 14px', borderBottom:'1px solid #f0d98a', verticalAlign:'top', background:'#fff' },
  tdL: { fontWeight:'600', color:'#7a4f00', whiteSpace:'nowrap', width:'220px' },
  code: { fontFamily:"'Courier New', monospace", fontSize:'0.88rem', whiteSpace:'pre-wrap' },
  dWrap: { margin:'24px 0', background:'#fffdf5', border:'1px solid #e8c84a', borderRadius:'8px', padding:'20px' },
  dTitle: { fontWeight:'700', fontSize:'0.95rem', color:'#7a4f00', marginBottom:'12px', textAlign:'center', letterSpacing:'0.02em' },
  dCaption: { fontSize:'0.84rem', color:'#666', textAlign:'center', marginTop:'10px', fontStyle:'italic' },
};

function InfoBox({ title, items }) {
  return (
    <div style={S.infoBox}>
      <div style={S.infoBoxTitle}>{title}</div>
      {items.map((item, i) => <div key={i} style={S.infoBoxItem}>{item}</div>)}
    </div>
  );
}

function Table2({ rows }) {
  return (
    <table style={S.table}>
      <thead><tr>
        <th style={{ ...S.th, width:'220px' }}>Concept</th>
        <th style={S.th}>Explanation / Detail</th>
      </tr></thead>
      <tbody>
        {rows.map(([label, content], i) => (
          <tr key={i}>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.tdL }}>{label}</td>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.code }}>{content}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

// ── Diagram: Protocol Comparison Overview ────────────────────────────
function DiagramComparison() {
  const W = 900, H = 320;
  const labelW = 120; // width reserved for row labels on the left
  const colW = 240;   // width of each protocol column
  const gap = 6;      // gap between columns
  const cols = ['#d4a000','#e07b00','#80a800'];
  const protocols = [
    { name:'UART', wires:'2 (TX, RX)', sync:'Async', nodes:'2 (point-to-point)', speed:'Up to ~5 Mbps', complexity:'Low' },
    { name:'SPI',  wires:'4 (MOSI,MISO,SCLK,CS)', sync:'Sync', nodes:'1 master, N slaves', speed:'Up to 100+ Mbps', complexity:'Medium' },
    { name:'I²C',  wires:'2 (SDA, SCL)', sync:'Sync', nodes:'Multi-master/slave', speed:'100k–3.4 Mbps', complexity:'Medium' },
  ];
  const rows = ['Wires','Sync','Nodes','Max Speed','Complexity'];
  const rowH = 44, startY = 66;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Protocol Comparison at a Glance</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>
          {cols.map((c,i)=>(
            <linearGradient key={i} id={`hg${i}`} x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor={c}/>
              <stop offset="100%" stopColor={c} stopOpacity="0.8"/>
            </linearGradient>
          ))}
        </defs>

        {/* Row label background strip */}
        <rect x={0} y={startY} width={labelW} height={rows.length*rowH} rx={4} fill="#fffbe6"/>

        {/* Column headers */}
        {protocols.map((p, i) => {
          const colX = labelW + gap + i*(colW + gap);
          return (
            <g key={i}>
              <rect x={colX} y={8} width={colW} height={48} rx={6} fill={`url(#hg${i})`}/>
              <text x={colX + colW/2} y={38} textAnchor="middle" fontSize="18" fontWeight="700" fill="#fff" fontFamily="'Georgia',serif">{p.name}</text>
            </g>
          );
        })}

        {/* Row labels */}
        {rows.map((r, ri) => (
          <g key={ri}>
            <rect x={0} y={startY + ri*rowH} width={labelW} height={rowH-2} rx={3}
              fill={ri%2===0?'#fffbe6':'#fff4cc'}/>
            <text x={8} y={startY + ri*rowH + rowH/2 + 5} fontSize="12" fontWeight="700"
              fill="#7a4f00" fontFamily="'Georgia',serif">{r}</text>
          </g>
        ))}

        {/* Data cells */}
        {protocols.map((p, pi) => {
          const vals = [p.wires, p.sync, p.nodes, p.speed, p.complexity];
          const colX = labelW + gap + pi*(colW + gap);
          return vals.map((v, ri) => {
            const parts = v.split('(');
            return (
              <g key={`${pi}-${ri}`}>
                <rect x={colX} y={startY + ri*rowH} width={colW} height={rowH-2} rx={3}
                  fill={ri%2===0?'#fffcf0':'#fffde8'} stroke="#e8c84a" strokeWidth="0.5"/>
                <text x={colX + colW/2} y={startY + ri*rowH + (parts[1] ? 16 : rowH/2 + 4)}
                  textAnchor="middle" fontSize="11" fill="#1a1200" fontFamily="'Courier New',monospace">{parts[0]}</text>
                {parts[1] && <text x={colX + colW/2} y={startY + ri*rowH + 30}
                  textAnchor="middle" fontSize="10" fill="#888" fontFamily="'Courier New',monospace">({parts[1]}</text>}
              </g>
            );
          });
        })}

        {/* Bottom border */}
        <line x1={0} y1={startY + rows.length*rowH} x2={W} y2={startY + rows.length*rowH} stroke="#d4a000" strokeWidth="1.5"/>
      </svg>
      <div style={S.dCaption}>All three are serial protocols — bits are transmitted one at a time over the wire(s)</div>
    </div>
  );
}

// ── Diagram: UART Frame ──────────────────────────────────────────────
function DiagramUARTFrame() {
  const W = 900, H = 220;
  const bits = [
    { label:'START', sub:'always 0', color:'#d4a000', w:80 },
    { label:'D0', sub:'LSB', color:'#b88000', w:60 },
    { label:'D1', sub:'', color:'#c49000', w:60 },
    { label:'D2', sub:'', color:'#b88000', w:60 },
    { label:'D3', sub:'', color:'#c49000', w:60 },
    { label:'D4', sub:'', color:'#b88000', w:60 },
    { label:'D5', sub:'', color:'#c49000', w:60 },
    { label:'D6', sub:'', color:'#b88000', w:60 },
    { label:'D7', sub:'MSB', color:'#c49000', w:60 },
    { label:'PARITY', sub:'optional', color:'#e07b00', w:70 },
    { label:'STOP', sub:'≥1 bit, logic 1', color:'#d4a000', w:85 },
  ];
  let cx = 20;
  const Y = 80, H2 = 70;

  // Build rects
  const rects = bits.map(b => {
    const x = cx; cx += b.w + 4;
    return { ...b, x };
  });
  const totalW = cx;
  const scale = (W - 40) / totalW;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>UART Data Frame Structure (8N1 format)</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>
          <marker id="arrowY" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#d4a000"/>
          </marker>
        </defs>
        {/* Idle line before frame */}
        <line x1={0} y1={Y+H2/2} x2={20} y2={Y+H2/2} stroke="#d4a000" strokeWidth="2"/>
        <text x={2} y={Y+H2/2-6} fontSize="10" fill="#888">IDLE(1)</text>
        {/* Bit rectangles */}
        {rects.map((r, i) => {
          const rx = 20 + r.x * scale;
          const rw = r.w * scale;
          const isHigh = (r.label === 'STOP' || r.label === 'IDLE');
          const lineY = isHigh ? Y : Y + H2;
          return (
            <g key={i}>
              <rect x={rx} y={Y} width={rw} height={H2} rx={3}
                fill={r.color} opacity="0.85"/>
              <text x={rx + rw/2} y={Y + H2/2 - 6} textAnchor="middle"
                fontSize="11" fontWeight="700" fill="#fff" fontFamily="'Georgia',serif">{r.label}</text>
              {r.sub && <text x={rx + rw/2} y={Y + H2/2 + 10} textAnchor="middle"
                fontSize="9" fill="#ffe8a0" fontFamily="'Courier New',monospace">{r.sub}</text>}
              {/* Vertical divider */}
              <line x1={rx} y1={Y-8} x2={rx} y2={Y+H2+8} stroke="#fff" strokeWidth="0.5" strokeDasharray="3,2" opacity="0.4"/>
            </g>
          );
        })}
        {/* Idle line after frame */}
        <line x1={20 + totalW*scale} y1={Y+H2/2} x2={W} y2={Y+H2/2} stroke="#d4a000" strokeWidth="2"/>
        <text x={20 + totalW*scale + 4} y={Y+H2/2-6} fontSize="10" fill="#888">IDLE(1)</text>
        {/* Annotation arrows */}
        <line x1={20} y1={Y+H2+30} x2={20 + rects[0].w*scale} y2={Y+H2+30}
          stroke="#d4a000" strokeWidth="1.5" markerEnd="url(#arrowY)"/>
        <text x={20 + rects[0].w*scale/2} y={Y+H2+46} textAnchor="middle" fontSize="10" fill="#7a4f00">1 bit (logic 0)</text>

        {/* Logic level key */}
        <rect x={W-160} y={10} width={150} height={60} rx={4} fill="#fffbe6" stroke="#d4a000"/>
        <text x={W-85} y={28} textAnchor="middle" fontSize="11" fontWeight="700" fill="#7a4f00">Logic Levels</text>
        <text x={W-150} y={46} fontSize="10" fill="#333">Logic 1 (HIGH): +3.3V or +5V</text>
        <text x={W-150} y={62} fontSize="10" fill="#333">Logic 0 (LOW):  0V (GND)</text>
      </svg>
      <div style={S.dCaption}>8N1: 8 data bits, No parity, 1 stop bit — the most common UART configuration</div>
    </div>
  );
}

// ── Diagram: UART Wiring ─────────────────────────────────────────────
function DiagramUARTWiring() {
  const W = 900, H = 200;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>UART Point-to-Point Wiring</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>
          <marker id="arrowTX" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#d4a000"/>
          </marker>
          <marker id="arrowRX" markerWidth="7" markerHeight="7" refX="1" refY="3.5" orient="auto-start-reverse">
            <polygon points="0 0, 6 3.5, 0 7" fill="#b88000"/>
          </marker>
        </defs>
        {/* Device A */}
        <rect x={20} y={40} width={200} height={120} rx={8} fill="#d4a000" opacity="0.9"/>
        <text x={120} y={90} textAnchor="middle" fontSize="16" fontWeight="700" fill="#fff">Device A</text>
        <text x={120} y={110} textAnchor="middle" fontSize="12" fill="#fff9cc">(Microcontroller)</text>
        <text x={195} y={125} textAnchor="end" fontSize="11" fill="#fff" fontWeight="700">TX →</text>
        <text x={195} y={155} textAnchor="end" fontSize="11" fill="#fff" fontWeight="700">RX ←</text>
        <text x={195} y={175} textAnchor="end" fontSize="11" fill="#fff" fontWeight="700">GND</text>

        {/* Device B */}
        <rect x={680} y={40} width={200} height={120} rx={8} fill="#b88000" opacity="0.9"/>
        <text x={780} y={90} textAnchor="middle" fontSize="16" fontWeight="700" fill="#fff">Device B</text>
        <text x={780} y={110} textAnchor="middle" fontSize="12" fill="#fff9cc">(Sensor / Module)</text>
        <text x={685} y={125} textAnchor="start" fontSize="11" fill="#fff" fontWeight="700">→ RX</text>
        <text x={685} y={155} textAnchor="start" fontSize="11" fill="#fff" fontWeight="700">← TX</text>
        <text x={685} y={175} textAnchor="start" fontSize="11" fill="#fff" fontWeight="700">GND</text>

        {/* TX wire (A TX → B RX) */}
        <line x1={220} y1={120} x2={680} y2={120} stroke="#d4a000" strokeWidth="3" markerEnd="url(#arrowTX)"/>
        <text x={450} y={112} textAnchor="middle" fontSize="11" fill="#7a4f00" fontWeight="700">TX → RX</text>

        {/* RX wire (B TX → A RX) */}
        <line x1={680} y1={150} x2={220} y2={150} stroke="#b88000" strokeWidth="3" markerEnd="url(#arrowTX)"/>
        <text x={450} y={168} textAnchor="middle" fontSize="11" fill="#7a4f00" fontWeight="700">TX → RX (reverse)</text>

        {/* GND wire */}
        <line x1={220} y1={170} x2={680} y2={170} stroke="#555" strokeWidth="2" strokeDasharray="5,3"/>
        <text x={450} y={185} textAnchor="middle" fontSize="10" fill="#555">Common Ground (GND)</text>
      </svg>
      <div style={S.dCaption}>Cross-connect: TX of one device connects to RX of the other. GND must be shared.</div>
    </div>
  );
}

// ── Diagram: SPI Bus ─────────────────────────────────────────────────
function DiagramSPIBus() {
  const W = 900, H = 360;
  // Master box: left side
  const mX = 20, mY = 80, mW = 170, mH = 160;
  // Slave boxes: evenly spaced across the right portion, all same vertical position
  const slaveY = 60, slaveW = 150, slaveH = 90;
  const slaves = [
    { label:'Slave 1', sub:'ADC',     x: 360 },
    { label:'Slave 2', sub:'Flash',   x: 540 },
    { label:'Slave 3', sub:'Display', x: 720 },
  ];
  // Signal row Y positions (below master/slaves)
  const sigY = { mosi:185, miso:215, sclk:245, cs0:275, cs1:275, cs2:275 };
  // Bus rail Y values
  const mosiRail = 185, misoRail = 210, sclkRail = 235;
  const csRails = [260, 280, 300];

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>SPI Bus — Master with Multiple Slaves (parallel)</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>
          <marker id="arrowSPI" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#e07b00"/>
          </marker>
          <marker id="arrowSPI2" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#b88000"/>
          </marker>
        </defs>

        {/* Master box */}
        <rect x={mX} y={mY} width={mW} height={mH} rx={8} fill="#d4a000"/>
        <text x={mX+mW/2} y={mY+38} textAnchor="middle" fontSize="15" fontWeight="700" fill="#fff">MASTER</text>
        <text x={mX+mW/2} y={mY+58} textAnchor="middle" fontSize="11" fill="#fff9cc">MCU / FPGA</text>
        {['MOSI','MISO','SCLK','CS0','CS1','CS2'].map((l,i)=>(
          <text key={i} x={mX+mW-6} y={mY+85+i*19} textAnchor="end" fontSize="10" fill="#fff" fontWeight="600">{l}</text>
        ))}

        {/* Slave boxes — all at same Y, no overlap */}
        {slaves.map((s, si) => (
          <g key={si}>
            <rect x={s.x} y={slaveY} width={slaveW} height={slaveH} rx={6} fill="#b88000" opacity="0.9"/>
            <text x={s.x+slaveW/2} y={slaveY+28} textAnchor="middle" fontSize="13" fontWeight="700" fill="#fff">{s.label}</text>
            <text x={s.x+slaveW/2} y={slaveY+48} textAnchor="middle" fontSize="10" fill="#ffecaa">{s.sub}</text>
            <text x={s.x+slaveW/2} y={slaveY+68} textAnchor="middle" fontSize="9" fill="#ffe" fontFamily="'Courier New',monospace">MOSI MISO SCLK CS</text>
          </g>
        ))}

        {/* ── Horizontal bus rails ── */}
        {/* MOSI rail: master → slaves (left to right) */}
        <line x1={mX+mW} y1={mosiRail} x2={W-20} y2={mosiRail} stroke="#e07b00" strokeWidth="2.5" markerEnd="url(#arrowSPI)"/>
        <text x={mX+mW+8} y={mosiRail-4} fontSize="10" fill="#e07b00" fontWeight="700">MOSI (data out →)</text>

        {/* MISO rail: slaves → master (right to left) */}
        <line x1={W-20} y1={misoRail} x2={mX+mW} y2={misoRail} stroke="#b88000" strokeWidth="2.5" markerEnd="url(#arrowSPI2)"/>
        <text x={mX+mW+8} y={misoRail+12} fontSize="10" fill="#b88000" fontWeight="700">MISO (data in ←)</text>

        {/* SCLK rail: dashed across all */}
        <line x1={mX+mW} y1={sclkRail} x2={W-20} y2={sclkRail} stroke="#7a4f00" strokeWidth="2" strokeDasharray="7,4"/>
        <text x={mX+mW+8} y={sclkRail+12} fontSize="10" fill="#7a4f00" fontWeight="700">SCLK (shared clock - - -)</text>

        {/* CS lines — each slave gets its own, slightly offset */}
        {slaves.map((s, si) => {
          const csY = csRails[si];
          const slvCx = s.x + slaveW/2;
          return (
            <g key={si}>
              {/* Horizontal segment from master to slave column */}
              <line x1={mX+mW} y1={csY} x2={slvCx} y2={csY}
                stroke={['#d4a000','#c49000','#a07000'][si]} strokeWidth="1.8" strokeDasharray="5,3"/>
              {/* Drop down to slave box bottom */}
              <line x1={slvCx} y1={csY} x2={slvCx} y2={slaveY+slaveH}
                stroke={['#d4a000','#c49000','#a07000'][si]} strokeWidth="1.8" strokeDasharray="5,3"/>
              <text x={mX+mW+8} y={csY+11} fontSize="9" fill={['#d4a000','#c49000','#a07000'][si]}>CS{si} (chip select)</text>
            </g>
          );
        })}

        {/* Vertical stubs connecting bus rails up to slave boxes */}
        {slaves.map((s, si) => {
          const slvCx = s.x + slaveW/2;
          return (
            <g key={si}>
              <line x1={slvCx} y1={slaveY+slaveH} x2={slvCx} y2={mosiRail} stroke="#e8c84a" strokeWidth="1" strokeDasharray="3,2" opacity="0.5"/>
            </g>
          );
        })}

        {/* Legend box */}
        <rect x={mX} y={314} width={W-mX*2} height={38} rx={4} fill="#fffbe6" stroke="#d4a000"/>
        <text x={mX+8} y={330} fontSize="10" fontWeight="700" fill="#7a4f00">Signal Meanings: </text>
        <text x={mX+108} y={330} fontSize="10" fill="#333">MOSI — Master Out Slave In (master → slave)   MISO — Master In Slave Out (slave → master)</text>
        <text x={mX+8} y={346} fontSize="10" fill="#333">SCLK — Serial Clock (master-generated, shared by all)   CS — Chip Select (active LOW, one per slave)</text>
      </svg>
      <div style={S.dCaption}>Each slave gets its own CS line. All other lines (MOSI, MISO, SCLK) are shared on the bus.</div>
    </div>
  );
}

// ── Diagram: SPI Timing ──────────────────────────────────────────────
function DiagramSPITiming() {
  const W = 900, H = 260;
  const nBits = 8;
  const bitW = 72, startX = 120, clkY = 40, mosiY = 120, misoY = 190;
  const H2 = 36;

  const clkPts = [startX];
  for (let i = 0; i < nBits; i++) {
    const x = startX + i * bitW;
    clkPts.push(x, x, x + bitW/2, x + bitW/2);
  }

  const sampleData = [1,0,1,1,0,0,1,0];
  const sampleDataMISO = [0,1,1,0,1,0,0,1];

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>SPI Timing Diagram — CPOL=0, CPHA=0 (Mode 0) — 8-bit Transfer</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        {/* CS bar */}
        <text x={10} y={28} fontSize="11" fontWeight="700" fill="#7a4f00" fontFamily="'Courier New',monospace">CS̄</text>
        <line x1={startX-20} y1={22} x2={startX} y2={22} stroke="#d4a000" strokeWidth="2"/>
        <line x1={startX} y1={22} x2={startX} y2={38} stroke="#d4a000" strokeWidth="2"/>
        <line x1={startX} y1={38} x2={startX + nBits*bitW} y2={38} stroke="#d4a000" strokeWidth="2"/>
        <line x1={startX + nBits*bitW} y1={38} x2={startX + nBits*bitW} y2={22} stroke="#d4a000" strokeWidth="2"/>
        <line x1={startX + nBits*bitW} y1={22} x2={W-10} y2={22} stroke="#d4a000" strokeWidth="2"/>

        {/* SCLK */}
        <text x={10} y={clkY+24} fontSize="11" fontWeight="700" fill="#7a4f00" fontFamily="'Courier New',monospace">SCLK</text>
        <line x1={startX-20} y1={clkY+H2} x2={startX} y2={clkY+H2} stroke="#e07b00" strokeWidth="2"/>
        {Array.from({length: nBits}).map((_,i) => {
          const x = startX + i*bitW;
          return (
            <g key={i}>
              <line x1={x} y1={clkY+H2} x2={x} y2={clkY} stroke="#e07b00" strokeWidth="2"/>
              <line x1={x} y1={clkY} x2={x+bitW/2} y2={clkY} stroke="#e07b00" strokeWidth="2"/>
              <line x1={x+bitW/2} y1={clkY} x2={x+bitW/2} y2={clkY+H2} stroke="#e07b00" strokeWidth="2"/>
              <line x1={x+bitW/2} y1={clkY+H2} x2={x+bitW} y2={clkY+H2} stroke="#e07b00" strokeWidth="2"/>
            </g>
          );
        })}

        {/* MOSI */}
        <text x={10} y={mosiY+24} fontSize="11" fontWeight="700" fill="#7a4f00" fontFamily="'Courier New',monospace">MOSI</text>
        {sampleData.map((b, i) => {
          const x = startX + i*bitW;
          const y = b===1 ? mosiY : mosiY+H2;
          const nextY = (sampleData[i+1] !== undefined && sampleData[i+1]!==b) ? (sampleData[i+1]===1?mosiY:mosiY+H2) : y;
          return (
            <g key={i}>
              <line x1={x} y1={y} x2={x+bitW} y2={y} stroke="#b88000" strokeWidth="2.5"/>
              {i < nBits-1 && sampleData[i] !== sampleData[i+1] &&
                <line x1={x+bitW} y1={y} x2={x+bitW} y2={nextY} stroke="#b88000" strokeWidth="2.5"/>}
              <text x={x+bitW/2} y={mosiY+H2/2+4} textAnchor="middle" fontSize="13" fontWeight="700"
                fill={b===1?'#7a4f00':'#aaa'}>{b}</text>
            </g>
          );
        })}

        {/* MISO */}
        <text x={10} y={misoY+24} fontSize="11" fontWeight="700" fill="#7a4f00" fontFamily="'Courier New',monospace">MISO</text>
        {sampleDataMISO.map((b, i) => {
          const x = startX + i*bitW;
          const y = b===1 ? misoY : misoY+H2;
          return (
            <g key={i}>
              <line x1={x} y1={y} x2={x+bitW} y2={y} stroke="#c49000" strokeWidth="2.5" strokeDasharray="5,3"/>
              {i < nBits-1 && sampleDataMISO[i] !== sampleDataMISO[i+1] &&
                <line x1={x+bitW} y1={y} x2={x+bitW} y2={sampleDataMISO[i+1]===1?misoY:misoY+H2} stroke="#c49000" strokeWidth="2.5" strokeDasharray="5,3"/>}
              <text x={x+bitW/2} y={misoY+H2/2+4} textAnchor="middle" fontSize="13" fontWeight="700"
                fill={b===1?'#7a4f00':'#aaa'}>{b}</text>
            </g>
          );
        })}

        {/* Sample points */}
        {sampleData.map((b, i) => {
          const x = startX + i*bitW + bitW/2;
          return <line key={i} x1={x} y1={clkY} x2={x} y2={misoY+H2} stroke="#d4a000" strokeWidth="0.8" strokeDasharray="3,2" opacity="0.5"/>;
        })}
        <text x={startX + bitW*3} y={H-8} fontSize="10" fill="#888" fontStyle="italic">▲ Dashed vertical lines = sample points (on rising edge in Mode 0)</text>

        {/* Bit numbers */}
        {sampleData.map((_, i) => (
          <text key={i} x={startX + i*bitW + bitW/2} y={H-22} textAnchor="middle" fontSize="9" fill="#b88000">b{7-i}</text>
        ))}
      </svg>
      <div style={S.dCaption}>MSB transmitted first. Simultaneous full-duplex: MOSI and MISO transfer at the same time.</div>
    </div>
  );
}

// ── Diagram: I2C Bus ─────────────────────────────────────────────────
function DiagramI2CBus() {
  const W = 900, H = 300;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>I²C Bus — Multi-Master, Multi-Slave on 2 Wires (Open-Drain + Pull-ups)</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        {/* VCC rail */}
        <line x1={300} y1={20} x2={300} y2={40} stroke="#d4a000" strokeWidth="2.5"/>
        <line x1={550} y1={20} x2={550} y2={40} stroke="#d4a000" strokeWidth="2.5"/>
        <text x={200} y={28} fontSize="11" fill="#d4a000" fontWeight="700">VCC (3.3V / 5V)</text>
        <line x1={280} y1={20} x2={W-30} y2={20} stroke="#d4a000" strokeWidth="1.5" strokeDasharray="4,2"/>

        {/* Pull-up resistors */}
        {[300, 550].map((x, i) => (
          <g key={i}>
            <rect x={x-10} y={40} width={20} height={30} rx={2} fill="none" stroke="#b88000" strokeWidth="2"/>
            <text x={x} y={58} textAnchor="middle" fontSize="9" fill="#b88000">Rp</text>
            <text x={x} y={90} textAnchor="middle" fontSize="9" fill="#7a4f00">{['SDA','SCL'][i]}</text>
            <line x1={x} y1={70} x2={x} y2={100} stroke="#b88000" strokeWidth="2"/>
          </g>
        ))}

        {/* SDA line */}
        <line x1={20} y1={100} x2={W-20} y2={100} stroke="#d4a000" strokeWidth="3"/>
        <text x={22} y={93} fontSize="11" fontWeight="700" fill="#7a4f00">SDA</text>

        {/* SCL line */}
        <line x1={20} y1={130} x2={W-20} y2={130} stroke="#e07b00" strokeWidth="3"/>
        <text x={22} y={123} fontSize="11" fontWeight="700" fill="#7a4f00">SCL</text>

        {/* Devices */}
        {[
          { label:'Master 1', sub:'MCU', x:80, type:'master' },
          { label:'Master 2', sub:'MCU', x:220, type:'master' },
          { label:'Slave 0x48', sub:'Temp Sensor', x:400, type:'slave' },
          { label:'Slave 0x50', sub:'EEPROM', x:560, type:'slave' },
          { label:'Slave 0x3C', sub:'OLED Display', x:730, type:'slave' },
        ].map((d, i) => {
          const fill = d.type==='master' ? '#d4a000' : '#b88000';
          return (
            <g key={i}>
              <line x1={d.x} y1={100} x2={d.x} y2={170} stroke={fill} strokeWidth="2"/>
              <line x1={d.x} y1={130} x2={d.x} y2={170} stroke={fill} strokeWidth="1" strokeDasharray="3,2"/>
              <rect x={d.x-55} y={170} width={110} height={60} rx={6} fill={fill} opacity="0.88"/>
              <text x={d.x} y={193} textAnchor="middle" fontSize="11" fontWeight="700" fill="#fff">{d.label}</text>
              <text x={d.x} y={211} textAnchor="middle" fontSize="9" fill="#ffecaa">{d.sub}</text>
              <text x={d.x} y={224} textAnchor="middle" fontSize="9" fill="#fff9cc">{d.type==='master'?'drives SCL':'open-drain'}</text>
            </g>
          );
        })}

        {/* Legend */}
        <rect x={20} y={248} width={860} height={44} rx={4} fill="#fffbe6" stroke="#d4a000"/>
        <text x={30} y={266} fontSize="10" fontWeight="700" fill="#7a4f00">Open-Drain:</text>
        <text x={105} y={266} fontSize="10" fill="#333">Devices can only pull the line LOW (to 0). The pull-up resistor (Rp, typically 4.7kΩ) pulls it HIGH when no device drives it.</text>
        <text x={30} y={284} fontSize="10" fontWeight="700" fill="#7a4f00">Addresses:</text>
        <text x={98} y={284} fontSize="10" fill="#333">7-bit addresses (0x00–0x7F) allow up to 127 unique devices on one bus (10-bit mode allows 1023).</text>
      </svg>
      <div style={S.dCaption}>Any master can initiate a transaction; arbitration prevents bus collisions automatically.</div>
    </div>
  );
}

// ── Diagram: I2C Frame ───────────────────────────────────────────────
function DiagramI2CFrame() {
  const W = 900, H = 200;
  const sections = [
    { label:'S', sub:'START', w:44, color:'#d4a000' },
    { label:'ADDR', sub:'7 bits', w:100, color:'#c49000' },
    { label:'R/W̄', sub:'1 bit', w:52, color:'#b88000' },
    { label:'ACK', sub:'from slave', w:60, color:'#e07b00' },
    { label:'DATA', sub:'8 bits', w:100, color:'#c49000' },
    { label:'ACK', sub:'from receiver', w:60, color:'#e07b00' },
    { label:'…', sub:'repeat', w:50, color:'#b88000' },
    { label:'P', sub:'STOP', w:44, color:'#d4a000' },
  ];
  let cx = 20;
  const Y = 60, H2 = 70;
  const rects = sections.map(s => { const x = cx; cx += s.w + 5; return { ...s, x }; });
  const totalW = cx;
  const scale = (W - 40) / totalW;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>I²C Message Frame Structure</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        {/* Idle line */}
        <line x1={0} y1={Y+H2/2} x2={20} y2={Y+H2/2} stroke="#d4a000" strokeWidth="2"/>
        {/* Sections */}
        {rects.map((r, i) => {
          const rx = 20 + r.x * scale;
          const rw = r.w * scale;
          return (
            <g key={i}>
              <rect x={rx} y={Y} width={rw} height={H2} rx={3} fill={r.color} opacity="0.88"/>
              <text x={rx + rw/2} y={Y + H2/2 - 4} textAnchor="middle"
                fontSize="11" fontWeight="700" fill="#fff">{r.label}</text>
              <text x={rx + rw/2} y={Y + H2/2 + 14} textAnchor="middle"
                fontSize="9" fill="#fff9cc" fontFamily="'Courier New',monospace">{r.sub}</text>
              <line x1={rx} y1={Y-6} x2={rx} y2={Y+H2+6} stroke="#fff" strokeWidth="0.5" opacity="0.4"/>
            </g>
          );
        })}
        {/* Idle after */}
        <line x1={20 + totalW*scale} y1={Y+H2/2} x2={W} y2={Y+H2/2} stroke="#d4a000" strokeWidth="2"/>

        {/* Annotation */}
        <text x={W/2} y={H-10} textAnchor="middle" fontSize="10" fill="#7a4f00" fontStyle="italic">
          ACK = receiver pulls SDA LOW for one clock cycle to acknowledge receipt
        </text>

        {/* START/STOP detail */}
        <rect x={10} y={145} width={300} height={40} rx={4} fill="#fffbe6" stroke="#d4a000"/>
        <text x={18} y={162} fontSize="9" fill="#333">START: SDA falls while SCL is HIGH</text>
        <text x={18} y={178} fontSize="9" fill="#333">STOP:  SDA rises while SCL is HIGH</text>
      </svg>
      <div style={S.dCaption}>Master holds SCL. All data bits are sampled when SCL is HIGH.</div>
    </div>
  );
}

// ── Diagram: I2C Address Byte ────────────────────────────────────────
function DiagramI2CAddr() {
  const W = 900, H = 160;
  const bits = ['A6','A5','A4','A3','A2','A1','A0','R/W̄'];
  const bitW = 80;
  const startX = (W - bits.length * bitW) / 2;
  const Y = 40, H2 = 60;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>I²C Address Byte (first byte after START)</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        {bits.map((b, i) => {
          const isRW = b === 'R/W̄';
          const fill = isRW ? '#e07b00' : (i%2===0 ? '#d4a000' : '#c49000');
          return (
            <g key={i}>
              <rect x={startX + i*bitW} y={Y} width={bitW-2} height={H2} rx={3} fill={fill} opacity="0.88"/>
              <text x={startX + i*bitW + (bitW-2)/2} y={Y+30} textAnchor="middle"
                fontSize="14" fontWeight="700" fill="#fff">{b}</text>
              <text x={startX + i*bitW + (bitW-2)/2} y={Y+50} textAnchor="middle"
                fontSize="10" fill="#fff9cc">{isRW ? '1=R 0=W' : `bit ${7-i}`}</text>
            </g>
          );
        })}
        {/* MSB/LSB labels */}
        <text x={startX} y={Y-8} fontSize="10" fill="#7a4f00" fontWeight="700">MSB</text>
        <text x={startX + 7*bitW} y={Y-8} textAnchor="end" fontSize="10" fill="#e07b00" fontWeight="700">LSB + R/W̄</text>
        {/* Brace */}
        <line x1={startX} y1={Y+H2+10} x2={startX + 7*bitW - 2} y2={Y+H2+10} stroke="#d4a000" strokeWidth="1.5"/>
        <text x={startX + 3*bitW} y={Y+H2+26} textAnchor="middle" fontSize="10" fill="#7a4f00">7-bit device address (e.g. 0x48 = 0b1001000)</text>
      </svg>
      <div style={S.dCaption}>Reserved addresses: 0x00 (general call), 0x01–0x07 (special use). 112 usable addresses in 7-bit mode.</div>
    </div>
  );
}

// ── Diagram: Baud Rate / Clock ───────────────────────────────────────
function DiagramBaudRate() {
  const W = 900, H = 180;
  const baudRates = [
    { label:'9600 baud', period:'~104 µs/bit', color:'#d4a000', bitW: 200 },
    { label:'115200 baud', period:'~8.7 µs/bit', color:'#e07b00', bitW: 100 },
    { label:'1 Mbaud', period:'1 µs/bit', color:'#b88000', bitW: 50 },
  ];

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>UART Baud Rate — Bit Period Comparison (scaled)</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        {baudRates.map((b, i) => {
          const y = 20 + i * 46;
          const H2 = 30;
          const nBits = Math.floor((W - 200) / b.bitW);
          return (
            <g key={i}>
              <text x={10} y={y+H2/2+5} fontSize="10" fontWeight="700" fill={b.color}>{b.label}</text>
              <text x={10} y={y+H2/2+20} fontSize="9" fill="#888">{b.period}</text>
              {Array.from({length: nBits}).map((_,j)=>(
                <g key={j}>
                  <rect x={200 + j*b.bitW} y={y} width={b.bitW-2} height={H2} rx={2}
                    fill={j%2===0?b.color:'none'} stroke={b.color} strokeWidth={j%2===0?0:1.5} opacity="0.7"/>
                </g>
              ))}
            </g>
          );
        })}
        <text x={200} y={H-8} fontSize="10" fill="#888" fontStyle="italic">
          ← Same time window shown: higher baud = more bits per second →
        </text>
      </svg>
      <div style={S.dCaption}>Both TX and RX must be configured to the same baud rate — there is no clock line in UART.</div>
    </div>
  );
}

// ── Main Export ──────────────────────────────────────────────────────
export default function SerialProtocols() {
  return (
    <div style={S.wrapper}>
      <h1 style={S.h1}>Serial Communication Protocols: UART · SPI · I²C</h1>
      <p style={S.p}>
        Embedded systems and microcontrollers use serial protocols to communicate with sensors, displays, memory chips,
        and other peripherals. The three most ubiquitous protocols are <strong>UART</strong> (Universal Asynchronous
        Receiver-Transmitter), <strong>SPI</strong> (Serial Peripheral Interface), and <strong>I²C</strong>
        (Inter-Integrated Circuit). Each makes different trade-offs in wire count, speed, complexity, and topology.
      </p>

      <DiagramComparison/>

      {/* ── UART ─────────────────────────────────────────────── */}
      <h2 style={S.h2}>UART — Universal Asynchronous Receiver-Transmitter</h2>
      <p style={S.p}>
        UART is the oldest and simplest of the three. It is <em>asynchronous</em> — there is no shared clock line.
        Instead, both sides agree on a baud rate (bits per second) in advance. Each byte is wrapped in a standardised
        frame containing a start bit, data bits, an optional parity bit, and one or more stop bits.
      </p>

      <DiagramUARTWiring/>
      <DiagramUARTFrame/>
      <DiagramBaudRate/>

      <Table2 rows={[
        ["Standard baud rates","Common values: 9600, 19200, 38400, 57600, 115200, 230400, 460800, 921600 bps\nBoth devices must match exactly — even 1% error can cause framing errors at high speeds"],
        ["Start bit","Always logic 0 (LOW) — signals start of frame to the receiver\nIdle line sits at logic 1 (HIGH); the LOW transition wakes the UART receiver"],
        ["Data bits","Typically 8 bits (one byte), LSB transmitted first\nHistorical variants: 5, 6, 7 bits (ASCII uses 7); rarely used today"],
        ["Parity bit","Even: total 1-bits including parity is even\nOdd: total 1-bits including parity is odd\nNone: most common — higher-level CRC/checksum used instead"],
        ["Stop bits","1, 1.5, or 2 bits at logic 1 (HIGH)\nGives receiver time to process the byte and resynchronise"],
        ["8N1 format","8 data bits, No parity, 1 stop bit — 10 total line bits per byte\nEfficiency: 8/10 = 80%"],
        ["RS-232 standard","Voltage levels: +3V to +15V = logic 0 (inverted!), -3V to -15V = logic 1\nRequires level-shifting ICs (e.g. MAX232) to interface with 3.3V/5V MCUs"],
        ["RS-485 standard","Differential pair (A/B) — common-mode noise rejection\nUp to 1200m cable, 32 nodes, 10 Mbps — used in industrial environments"],
        ["Flow control","RTS/CTS hardware handshake: request/clear to send signals prevent buffer overflow\nXON/XOFF software flow control using special 0x11/0x13 bytes"],
        ["FIFO buffers","Most UART hardware includes 16–256 byte FIFOs to handle bursts\nInterrupt fired when buffer reaches threshold — prevents CPU polling"],
        ["Framing error","Detected when stop bit is not found where expected (baud rate mismatch)\nParity error: received parity bit does not match computed parity"],
        ["USB-UART bridges","CH340, CP2102, FTDI FT232 — convert USB to UART for PC communication\nArduino Uno uses ATmega16U2 as USB-UART bridge on-board"],
      ]}/>

      <InfoBox title="UART Quick Reference" items={[
        "Wires: 2 minimum (TX, RX) + optional RTS, CTS, GND",
        "Topology: Point-to-point only — exactly 2 devices",
        "Synchronisation: Asynchronous — no clock wire, baud rate must match",
        "Direction: Full-duplex (simultaneous TX and RX)",
        "Speed: 9600 bps to ~5 Mbps (depends on hardware)",
        "Frame overhead: Start + Stop bits = 20% overhead at 8N1",
        "No built-in addressing — cannot directly support multiple devices",
      ]}/>

      {/* ── SPI ──────────────────────────────────────────────── */}
      <h2 style={S.h2}>SPI — Serial Peripheral Interface</h2>
      <p style={S.p}>
        SPI is a <em>synchronous</em>, <em>full-duplex</em> protocol introduced by Motorola. The master generates
        a clock (SCLK) that both sides use to latch data. This eliminates baud rate negotiation and enables very
        high speeds. Data flows simultaneously in both directions — one bit out on MOSI for every bit in on MISO —
        making SPI ideal for ADCs, DACs, Flash memory, displays, and SD cards.
      </p>

      <DiagramSPIBus/>
      <DiagramSPITiming/>

      <Table2 rows={[
        ["CPOL (Clock Polarity)","CPOL=0: clock idles LOW, active HIGH pulses\nCPOL=1: clock idles HIGH, active LOW pulses"],
        ["CPHA (Clock Phase)","CPHA=0: data sampled on leading edge, shifted on trailing edge\nCPHA=1: data shifted on leading edge, sampled on trailing edge"],
        ["4 SPI Modes","Mode 0 (CPOL=0, CPHA=0) — most common; Mode 1 (0,1); Mode 2 (1,0); Mode 3 (1,1)\nMust match between master and slave — check datasheet"],
        ["Chip Select (CS/SS)","Active LOW: master pulls CS LOW to select that slave\nOnly one CS can be active at a time (normally)\nEach additional slave requires one more CS pin on the master"],
        ["Daisy-chain mode","MISO of slave N → MOSI of slave N+1; all share SCLK; single CS\nEffective for shift registers and LED driver ICs\nAll N slaves receive N×8 clock pulses before valid data appears"],
        ["Clock speed","No protocol maximum — limited by PCB trace length and slave specs\nTypically 1–80 MHz; some SPI Flash chips support 100+ MHz"],
        ["Transaction","Master asserts CS LOW → clocks out N bytes (MOSI) while reading N bytes (MISO) → deasserts CS HIGH\nNo ACK mechanism — master cannot know if slave missed data"],
        ["Half-duplex SPI","Some devices (e.g. TFT displays) use MOSI only — MISO not connected\nFrees a pin; write-only communication"],
        ["Quad-SPI / Octal SPI","4 or 8 data lines instead of 1 — for very high speed Flash access\nUsed in microcontrollers with QSPI peripherals (e.g. STM32, ESP32)"],
        ["Word size","Typically 8 bits; some peripherals use 16-bit or arbitrary widths\nSPI peripheral register (e.g. SPI_CR1) configures DFF bit"],
        ["DMA transfer","SPI + DMA allows block transfers without CPU involvement\nEssential for SPI displays and audio DACs at high throughput"],
        ["Voltage levels","No built-in level shifting — 3.3V and 5V devices need level translators\nBi-directional MOSFET shifters or dedicated ICs (e.g. TXB0108)"],
      ]}/>

      <InfoBox title="SPI Quick Reference" items={[
        "Wires: 4 (MOSI, MISO, SCLK, CS) + 1 CS per additional slave",
        "Topology: Single master, multiple slaves (each needs own CS)",
        "Synchronisation: Synchronous — master provides clock",
        "Direction: Full-duplex (simultaneous in both directions)",
        "Speed: 1 MHz to 100+ MHz",
        "No addressing — slaves selected by dedicated CS lines",
        "No acknowledgement — master cannot confirm slave received data",
      ]}/>

      {/* ── I2C ──────────────────────────────────────────────── */}
      <h2 style={S.h2}>I²C — Inter-Integrated Circuit</h2>
      <p style={S.p}>
        I²C (pronounced "I-squared-C" or "I-two-C") was designed by Philips Semiconductor in 1982 to connect
        low-speed peripherals inside a circuit board using only <strong>2 wires</strong>. It is synchronous like SPI
        but adds a proper addressing scheme so dozens of devices can share the same two wires. The bus uses
        open-drain signalling with pull-up resistors — any device can pull the line LOW, but none can drive it HIGH.
      </p>

      <DiagramI2CBus/>
      <DiagramI2CFrame/>
      <DiagramI2CAddr/>

      <Table2 rows={[
        ["Open-drain / open-collector","Devices can only sink current (pull LOW) — never source it\nPull-up resistor (typically 4.7kΩ at 100kHz, 2.2kΩ at 400kHz) pulls HIGH when bus is free\nAllows wired-AND: any device pulling LOW wins — used for clock stretching and arbitration"],
        ["Speed modes","Standard: 100 kbps\nFast: 400 kbps\nFast-plus: 1 Mbps\nHigh-speed: 3.4 Mbps\nUltra-fast: 5 Mbps (unidirectional only)"],
        ["7-bit addressing","112 usable addresses (16 reserved); addresses 0x00–0x7F\nPacked into first byte: 7 addr bits + 1 R/W̄ bit"],
        ["10-bit addressing","Allows 1023 unique devices using two-byte address sequence\nFirst byte: 11110xx0 (special prefix), second: remaining 8 address bits"],
        ["ACK / NACK","After each byte, receiver pulls SDA LOW (ACK) or releases it HIGH (NACK)\nMaster must receive ACK before sending next byte\nNACK can mean: wrong address, bus busy, device not ready, end of transfer"],
        ["Clock stretching","Slave holds SCL LOW to pause the master while it prepares data\nMaster must monitor SCL and wait until slave releases it\nNot all masters support clock stretching — check hardware"],
        ["Arbitration","If two masters start simultaneously, they both watch SDA\nIf master writes 1 but reads 0, it lost arbitration and backs off\nWinning master continues uninterrupted — no collision corruption"],
        ["Repeated START","Master sends new START without releasing bus (no STOP first)\nAllows atomic multi-byte transactions (e.g. write register, then read)\nPrevents another master from seizing the bus between operations"],
        ["General Call (0x00)","Broadcast address — all devices listen\nSecond byte: reset command (0x06) or other general commands\nMost devices ignore it unless specifically implemented"],
        ["Pull-up resistor sizing","Too large: slow rise time limits maximum speed\nToo small: wastes power and overloads open-drain drivers\nCalculation: Rp_max = (VCC - V_OL) / I_OL where I_OL ≈ 3mA"],
        ["I2C scanner","Write to every address 0x01–0x7E; if ACK received, device is present\nEssential debug tool — implemented in <10 lines of code"],
        ["SMBus","System Management Bus — subset of I2C with stricter timing, voltage, and timeout rules\nUsed for laptop battery management, CPU voltage regulators (PMBus)"],
      ]}/>

      <InfoBox title="I²C Quick Reference" items={[
        "Wires: 2 (SDA, SCL) + GND — regardless of number of devices",
        "Topology: Multi-master, multi-slave on shared bus",
        "Synchronisation: Synchronous — master provides SCL clock",
        "Direction: Half-duplex (SDA shared for data in both directions)",
        "Speed: 100 kbps (standard) to 3.4 Mbps (high-speed)",
        "Addressing: 7-bit (112 devices) or 10-bit (1023 devices)",
        "ACK/NACK after every byte — built-in error detection",
        "Open-drain bus: requires pull-up resistors (typically 2.2–10 kΩ)",
      ]}/>

      {/* ── Side-by-side comparison ──────────────────────────── */}
      <h2 style={S.h2}>Detailed Side-by-Side Comparison</h2>
      <Table2 rows={[
        ["Wire count","UART: 2 (TX, RX)\nSPI: 4 + 1 per additional slave\nI²C: 2 always"],
        ["Clock","UART: None — asynchronous, baud rate agreed out-of-band\nSPI: Dedicated SCLK, master-driven\nI²C: Shared SCL, master-driven (slave can stretch)"],
        ["Duplex","UART: Full-duplex (separate TX and RX)\nSPI: Full-duplex (simultaneous MOSI and MISO)\nI²C: Half-duplex (SDA is bidirectional)"],
        ["Topology","UART: Point-to-point only (2 devices)\nSPI: 1 master + N slaves (N CS pins required)\nI²C: Multi-master + multi-slave on shared 2-wire bus"],
        ["Addressing","UART: None — direct wire connection implies identity\nSPI: None — CS line selects device\nI²C: 7-bit or 10-bit address embedded in message"],
        ["Max speed","UART: ~5 Mbps (hardware dependent)\nSPI: 100+ MHz (QSPI even faster)\nI²C: 3.4 Mbps (high-speed mode)"],
        ["Error detection","UART: Optional parity bit (1-bit error detection only)\nSPI: None built-in — relies on application-level CRC\nI²C: ACK/NACK every byte; arbitration detection"],
        ["Typical use cases","UART: GPS, Bluetooth modules, PC debug console, RS-232, RS-485\nSPI: SD cards, SPI Flash, TFT displays, ADC/DAC chips\nI²C: Sensors (temp, IMU, pressure), EEPROM, RTC, OLED displays"],
        ["Voltage levels","UART: 3.3V or 5V logic (RS-232: ±12V)\nSPI: 3.3V or 5V (no open-drain)\nI²C: Open-drain — VCC can be 1.8V to 5V; mixed voltages need level shifting"],
        ["Distance","UART/RS-232: ~15m; RS-485: ~1200m\nSPI: <1m (PCB only at high speed)\nI²C: <1m on PCB; <4m with signal buffers"],
        ["Hardware complexity","UART: Simple shift register + baud generator\nSPI: Shift register + clock + CS logic\nI²C: Start/stop detector + arbitration + ACK logic — most complex"],
        ["Software complexity","UART: Easiest — send/receive bytes\nSPI: Easy — but must manage CS and mode\nI²C: Moderate — address, R/W, ACK handling, clock stretching"],
      ]}/>

      {/* ── Choosing a protocol ──────────────────────────────── */}
      <h2 style={S.h2}>Choosing the Right Protocol</h2>
      <p style={S.p}>
        The best protocol depends on your system's constraints. Consider wire count, required speed, number of
        devices, and whether the peripheral chips support the protocol.
      </p>
      <Table2 rows={[
        ["Use UART when…","Communicating with exactly one other device (PC, GPS, BT module)\nYou need full-duplex and simplicity\nLong-distance communication (RS-485 variant)\nDebugging: serial console on any MCU"],
        ["Use SPI when…","You need maximum speed (displays, Flash, DAC/ADC)\nFull-duplex transfer matters\nYou have enough GPIO pins for CS lines\nThe peripheral only comes in SPI"],
        ["Use I²C when…","Pin count is critical (only 2 wires for many devices)\nYou have many slow/medium-speed peripherals (sensors, EEPROMs, RTCs)\nMulti-master bus sharing is needed\nHalf-duplex is acceptable"],
        ["Mixed systems","Many embedded designs use all three simultaneously\nExample: I²C for sensors + SPI for display + UART for Bluetooth\nMost MCUs have multiple UART/SPI/I²C peripheral blocks in hardware"],
        ["Protocol bridges","Chips like SC18IS602 convert I²C commands to SPI transactions\nI²C GPIO expanders (e.g. MCP23017) add SPI-less GPIO over 2 wires\nUseful when a target protocol is not natively supported by MCU"],
      ]}/>

      <InfoBox title="Key Formulae & Constants" items={[
        "UART bit period: T_bit = 1 / baud_rate  (e.g. 9600 baud → 104.17 µs/bit)",
        "UART bytes/sec (8N1): throughput = baud_rate / 10  (10 bits per byte with start + stop)",
        "SPI clock: f_SCLK must be ≤ f_max of slowest slave chip",
        "I²C pull-up max: Rp_max = (VCC - 0.4V) / 3mA  (VCC=3.3V → Rp_max ≈ 967Ω)",
        "I²C pull-up min: Rp_min = VCC / 3mA  (ensures VOL spec is met)",
        "I²C rise time: t_r = 0.8473 × Rp × C_bus  (must be < 1000ns at 100kHz mode)",
        "SPI throughput: N_bits / f_SCLK  (e.g. 8 bits at 10 MHz → 1.25 MB/s per transfer)",
        "I²C bus capacitance limit: 400 pF maximum (limits number of devices and trace length)",
      ]}/>
    </div>
  );
}